// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2HODD","cell":"ColumnAccessor_cell__3XW87","firstCellAccent":"ColumnAccessor_firstCellAccent__1o5AT"};